import type {
  FetchZoneDefinitionListParams,
  ZoneDefinition
} from 'Services/ProductManagement/Features/ZoneDefinition/types'
import { createBaseApi } from 'Util/ApiClient'

export const zoneDefinitionApi = createBaseApi({
  reducerPath: 'zoneDefinitionApi',
  tagTypes: ['ZoneDefinition']
}).injectEndpoints({
  endpoints: builder => ({
    getZoneDefinitions: builder.query<ZoneDefinition[], FetchZoneDefinitionListParams | undefined>({
      query: params => ({
        url: '/api/v1/zone-definition/',
        params
      }),
      providesTags: result =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'ZoneDefinition', id }) as const),
              { type: 'ZoneDefinition', id: 'LIST' }
            ]
          : [{ type: 'ZoneDefinition', id: 'LIST' }],
      transformResponse: (response: { resources: ZoneDefinition[] }) => response.resources ?? []
    }),
    getSingleZoneDefinition: builder.query<ZoneDefinition, string>({
      query: id => `/api/v1/zone-definition/${id}/`,
      providesTags: (_result, _error, id) => [{ type: 'ZoneDefinition', id }]
    }),
    createSingleZoneDefinition: builder.mutation<ZoneDefinition, Partial<ZoneDefinition>>({
      query: data => ({
        url: `/api/v1/zone-definition/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: [{ type: 'ZoneDefinition', id: 'LIST' }]
    }),
    updateSingleZoneDefinition: builder.mutation<ZoneDefinition, Partial<ZoneDefinition>>({
      query: data => ({
        url: `/api/v1/zone-definition/${data.id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'ZoneDefinition', id }]
    }),
    deleteSingleZoneDefinition: builder.mutation<Record<string, never>, string>({
      query: id => ({
        url: `/api/v1/zone-definition/${id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: [{ type: 'ZoneDefinition', id: 'LIST' }]
    })
  })
})

export const {
  useGetZoneDefinitionsQuery,
  useGetSingleZoneDefinitionQuery,
  useCreateSingleZoneDefinitionMutation,
  useUpdateSingleZoneDefinitionMutation,
  useDeleteSingleZoneDefinitionMutation
} = zoneDefinitionApi
